export default {
    SET_PAGINATION(state, data) {
        state.pagination = data
    },
    ADD_PERMISSION(state, permission) {
      state.permissions.push(permission)
    },
    UPDATE_PERMISSION(state, permission) {
      const permissionIndex = state.permissions.findIndex((e) => e.id === permission.id)
      Object.assign(state.permissions[permissionIndex], permission)
    },
    SET_PERMISSION (state, permissions) {
      state.permissions = permissions
    },
    REMOVE_RECORD (state, itemId) {
      const permissionIndex = state.permissions.findIndex((u) => u.id === itemId)
      state.permissions.splice(permissionIndex, 1)
    }
  }
  